import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=ffc57c76"
import script from "./TransactionsList.vue?vue&type=script&lang=js"
export * from "./TransactionsList.vue?vue&type=script&lang=js"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=ffc57c76&prod&lang=scss"
import style1 from "./TransactionsList.vue?vue&type=style&index=1&id=ffc57c76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports